function Welcome() {
  return <>
    <section className='heading'>
      <h1 className='roman'>
      Roman's                           
      </h1>
      <h1>County Jail</h1>
      {/* IN INDEX.CSS THIS WOULD BE .heading p */}
      <p>Keeping the general public safe from baddies since 1898</p>
    </section>

    {/* <div style={{ display: "flex" }}>
      <ReactRoundedImage image={"https://i.imgur.com/itUMrBM.png"} />
      <ReactRoundedImage
        image={"https://i.imgur.com/itUMrBM.png"}
        roundedColor="#321124"
        imageWidth="150"
        imageHeight="150"
        roundedSize="13"
      />
    </div> */} 
  </>
}

export default Welcome